function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.166,1.06C15.277,1.277 14.427,1.534 13.624,1.83C9.277,3.444 6.234,6.21 4.212,9.503C3.007,11.466 2.177,13.606 1.631,15.786L17.285,31.434C18.175,31.217 19.024,30.96 19.828,30.664C24.174,29.05 27.217,26.284 29.239,22.991C30.444,21.029 31.274,18.888 31.814,16.715L16.166,1.06ZM32.479,12.908C32.881,9.167 32.572,5.519 31.972,2.608C31.794,1.758 31.116,1.099 30.253,0.954C26.42,0.316 23.015,0.164 20.005,0.434L32.479,12.908ZM13.446,32.06L0.972,19.586C0.57,23.327 0.88,26.976 1.479,29.887C1.657,30.736 2.335,31.395 3.198,31.54C7.031,32.179 10.436,32.33 13.446,32.06ZM17.035,10.234C17.443,9.826 18.115,9.826 18.524,10.234L22.739,14.449C23.147,14.857 23.147,15.529 22.739,15.938C22.33,16.346 21.659,16.346 21.25,15.938L17.035,11.723C16.627,11.314 16.627,10.642 17.035,10.234ZM13.874,13.395C14.282,12.987 14.954,12.987 15.362,13.395L19.577,17.61C19.986,18.019 19.986,18.691 19.577,19.099C19.169,19.507 18.497,19.507 18.089,19.099L13.874,14.884C13.466,14.475 13.466,13.804 13.874,13.395ZM10.713,16.557C11.121,16.148 11.793,16.148 12.201,16.557L16.416,20.772C16.824,21.18 16.824,21.852 16.416,22.26C16.008,22.668 15.336,22.668 14.928,22.26L10.713,18.045C10.304,17.637 10.304,16.965 10.713,16.557Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sports.6e21cbc17b19982a43c0780db2b5ebcb.svg";